import { Pubsub } from '@/common/utils/pubsub';
import { $k18n } from '@/common/i18n';
import { useQuery, useQuerys } from '@/hooks/useQuery';
import { getPageProps } from '@kibt/krn-utils';

/** 优惠券位置 */
export enum ECouponPositionType {
    /** 横幅优惠券 */
    MinCoupon = 1,
    /** 弹出框优惠券列表 */
    LargeCoupon = 2,
}

/** 优惠券气泡类型展示 */
export enum ECouponBubbleType {
    /** 无需关注 */
    UN_RECOGNIZED_TAG = 0,
    /** 特殊UI */
    SPECIAL_UI_TAG = 1,
    /** 新人折扣 */
    NEW_USER_TAG = 2,
    /** 回归专属特惠 */
    COMEBACK_USER_TAG = 3,
    /** 8.8限时特惠 */
    BIG_SALE_88 = 4,
    /** 新人72小时赔付 */
    NEW_USER_72_HOURS = 5,
}

// 秒杀状态2（进行中）/4（限购）/5（无秒杀库存）时，展示秒杀信息
export const showFlashActivity = status => [2, 4, 5].includes(status);

export const getBottomBenfitParams = pageRawData => {
    let log = '';
    // 上报ugc埋点
    if (pageRawData?.displaySpuUgc) {
        log = `${log},UGC_multi_select`;
    }
    return log;
};

// 达人uid和merchantid,商详页不在做转换，透传到提单页由交易做兜底
export const useGetSellerParams = () => {
    const { sellerUserId = 0, merchantId = 0, sellerMerchantId = 0 } = useQuerys();

    return {
        // 商详页、短视频双列从url中的merchantId获取达人店铺id，其他页面从url中的sellerMerchantId获取达人店铺id
        sellerMerchantId: ['Detail', 'EcomRecommendGoods'].includes(getPageProps()?.bundleId) ? merchantId : sellerMerchantId,
        sellerUserId: sellerUserId,
    };
};

export const useExtParamsObject = () => {
    const ext = useQuery<string>('extParams') || '';
    const cc = useQuery('cc') as string;
    const source = useQuery('source');
    const via = useQuery('via');
    let res: any = {};
    try {
        res = JSON.parse(decodeURIComponent(ext || '{}'));
        if (source === 'out_share') {
            res.cT = cc === 'IM_CONVERSATION' ? 7 : 6;
        }
        if (via === '1') {
            res.cT = 0;
        }
    } catch (e) {
        console.log('json key error', e);
    }
    return res;
};

// RN中使用 URL.searchParams 会报错，所以使用此方法
function getURLParams(parameterName, url) {
    const name = parameterName.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return null;
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function useExtParamsFromUrl() {
    const { cc, source } = useQuerys();

    // 通过列表中下发链接的参数获取extParams
    const getExtParamsFromUrl = (url: string) => {
        // 获取链接的参数
        const ext = getURLParams('extParams', url) || '';
        let res;
        try {
            res = JSON.parse(decodeURIComponent(ext || '{}'));
            console.log('extParams', res);
            if (source === 'out_share') {
                res.cT = cc === 'IM_CONVERSATION' ? 7 : 6;
            }
        } catch (e) {
            console.log('json key error', e);
        }
        return res;
    };

    return { getExtParamsFromUrl };
}

export const useChannelCouponTag = currentChannelType => {
    const componentName = useQuery<string>('componentName');
    const extParams = useExtParamsObject();
    const cT = +extParams?.cT;
    console.log('extParams', extParams);
    console.log('cT', cT);
    // 目前只有商详透出
    if (!['Detail'].includes(componentName)) {
        return '';
    }

    // 短视频
    if (cT === 1 && currentChannelType === 6) {
        return $k18n({ id: 'k_474807' });
    }

    // 短视频单双列推荐
    if ([12, 13].includes(cT) && currentChannelType === 9) {
        return $k18n({ id: 'k_474807' });
    }

    return '';
};

/** 优惠券左上角气泡文案展示 */
export const useCouponTagInfo = (couponInfo, couponType?: ECouponPositionType) => {
    const couponTags = couponInfo?.couponTag || [];
    /** 默认走特殊UI配置 */
    let tagText = useChannelCouponTag(couponInfo?.currentChannelType);
    /** 横幅优惠券展示 */
    if (couponType === ECouponPositionType.MinCoupon) {
        try {
            const $k18nMap = {
                [ECouponBubbleType.BIG_SALE_88]: $k18n({ id: 'k_1237060' }) || '',
                [ECouponBubbleType.COMEBACK_USER_TAG]: $k18n({ id: 'k_1237059' }) || '',
                [ECouponBubbleType.NEW_USER_TAG]: $k18n({ id: 'k_1237058' }) || '',
                [ECouponBubbleType.NEW_USER_72_HOURS]: $k18n({ id: 'k_1251985' }) || '',
                /** 其他情况，后端不在这个逻辑返回，虽说是一个纬度的，但是不在一个字段判断 😓*/
            };
            /** 优先级展示处理 大促活动>回流>新用户>特定场域券 */
            const tagType = (couponTags.length && (couponTags as number[]).sort((a, b) => b - a))[0] || -1;
            const _tag = $k18nMap[tagType as ECouponBubbleType];
            if (_tag) {
                tagText = _tag;
            }
        } catch (error) {}
    }

    return tagText;
};

export const detailPubsub = new Pubsub();
